import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {CrearConversacionFG} from './modal-crear-conversacion.component';
import {Observable} from 'rxjs';
import {Conversacion} from '../../interfaces/conversacion';

@Injectable({
  providedIn: 'root'
})
export class CrearConversacionService {
  private readonly conversacionUrl: string;

  constructor(private httpClient: HttpClient) {
    this.conversacionUrl = environment.apiUrl + '/shared/conversacion';
  }

  public __invoke(parametros: CrearConversacionFG): Observable<Conversacion> {
    return this.httpClient.post<Conversacion>(this.conversacionUrl, parametros);
  }
}
